import type { ReactNode } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import { useAuth } from '../lib/auth.js';

interface NavItem {
  to: string;
  label: string;
  hint: string;
  end?: boolean;
}

/**
 * The seven tabs, in the order a run actually happens: check the phone system,
 * configure the org, make a call, verify what it left behind.
 */
const NAV: NavItem[] = [
  { to: '/', label: 'Dashboard', hint: 'Overall health', end: true },
  { to: '/api-health', label: 'PBX API health', hint: 'Both API surfaces' },
  { to: '/org-setup', label: 'Salesforce org setup', hint: 'Install and configure' },
  { to: '/live-call', label: 'Live call test', hint: 'Make a real call' },
  { to: '/post-call', label: 'Post-call checks', hint: 'What the call left behind' },
  { to: '/runs', label: 'Runs and reports', hint: 'History and evidence' },
  { to: '/settings', label: 'Settings', hint: 'Credentials and environments' },
];

export function AppShell(): ReactNode {
  const auth = useAuth();

  return (
    <div className="shell">
      <nav className="shell__nav" aria-label="Sections">
        <div className="shell__brand">
          <span className="shell__brand-name">sfpbxtestbot</span>
          <span className="shell__brand-tag">RocketPBX in Salesforce, end to end</span>
        </div>

        <div className="shell__links">
          {NAV.map((item) => (
            <NavLink key={item.to} to={item.to} end={item.end} className="shell__link">
              <span>{item.label}</span>
              <span className="shell__link-hint">{item.hint}</span>
            </NavLink>
          ))}
        </div>

        <div className="shell__footer">
          {auth.user ? (
            <div className="shell__user">
              <span>{auth.user.email}</span>
              <button type="button" className="shell__signout" onClick={() => void auth.signOut()}>
                Sign out
              </button>
            </div>
          ) : null}
          <span>Every run keeps its assertions and logs.</span>
          <span>Nothing runs without your credentials.</span>
        </div>
      </nav>

      <main className="shell__main">
        <Outlet />
      </main>
    </div>
  );
}
